import { Environment } from '@dice/app/types/env.type';
import { NgxLoggerLevel } from 'ngx-logger';

const host = 'dice-api-gateway-prod.scapp.swisscom.com/';
const https = 'https://';
const wss = 'wss://';

export const PROD_ENV_CONFIG: Environment = {
  name: 'sc-production',
  hostNames: ['buda.swisscom.com', 'dice.scapp-corp.swisscom.com', 'buda.corproot.net', 'localhost:1000'],
  enableDebugInfo: false,
  isProduction: true,
  publicStates: ['login'],
  apiEndpoint: `${https + host}`,
  wsEndpoint: `${wss + host}`,
  wsEndpointForUCCP: `${wss + host}`,
  agentViewEndpoint: `agent-view/`,
  anomalyEndpoint: `dice-anomalies/api/anomalies/`,
  auditingEndpoint: `auditing/`,
  budaConfigurationEndpoint: `buda-masterdata/`,
  budaStatisticsConsumerEndpoint: 'buda-message-proxy/',
  budaStatisticsConsumerEndpointForUCCP: 'buda-message-proxy-uccp/',
  agentViewStatisticsConsumerEndpoint: `buda-message-proxy-agentview/`,
  agentInfoStatisticsConsumerEndpoint: `buda-message-proxy-agentinfo/`,
  configEndpoint: `dice-config/api/config/`,
  easyArchitectEndpoint: 'https://easy-architect.uccp-integration-production.icp.corproot.net/',
  datatableBackupEndpoint: 'https://uccp-soe-datatable-backup.uccp-integration-production.icp.corproot.net/',
  businessInsightsEndpoint: 'https://uccp-soi-business-insights.uccp-integration-production.icp.corproot.net/',
  callbackAdminEndpoint: `https://callback-admin.uccp-integration-production.icp.corproot.net/`,
  callbackAnalyticsEndpoint: `https://callback-analytics.uccp-integration-production.icp.corproot.net/`,
  dataExchangeEndpoint: `data-exchange/`,
  wfmDataEndpoint: `https://wfm-sap-etl.uccp-integration-production.icp.corproot.net/`,
  diceUiRedirectPage: 'https://dice-ui.scapp-corp.swisscom.com/',
  eimaEndpoint: `eima/`,
  eimaDREndpoint: `eima-dr/`,
  notifications: `${wss + host}notification/push-message-endpoint`,
  octEndpoint: `chat-campaign-tool/`,
  statisticsConsumerEndpoint: `${wss + host}statistics-consumer/websocket`,
  transfertoolAdminURL: 'https://www.swisscom.ch/omni-transfertool-admin/login',
  userManagementEndpoint: `user-management/`,
  userManualURL: 'https://wiki.swisscom.com/pages/viewpage.action?pageId=617222684',
  logEndpoint: 'https://dice-api-gateway-prod.scapp.swisscom.com/dice-splunk-forwarder/ui/log',
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.WARN,
  variant: 'dice-ui-prod',
  agentViewManualURL: 'https://wiki.swisscom.com/x/3yHdL',
  budaStatusURL: 'https://buda.swisscom.com/status',
  cxGenesysModifierURL: 'buda-cx-genesys-modifier/',
  apiProviderURL: 'buda-cx-api-provider/',
};
